// @spec SUP-STR-027
import { createFileRoute } from '@tanstack/react-router';

import { LoginPage } from '@/features/portal/auth';

export const Route = createFileRoute('/portal/auth/login')({
  component: PortalLoginRoute,
});

/**
 * Portal login route.
 *
 * This is a PUBLIC page that allows supplier contacts to login
 * to their portal account.
 */
function PortalLoginRoute() {
  return <LoginPage />;
}
